import { isArray, isNil } from "./types";

export const encodeArrayToURL = (key, array) => {
    return array
        .map((value, index) => {
            return `${key}[${index}]=${value}`;
        })
        .join("&");
};

export const encodeURLWithParams = (url, params) => {
    const encodedParams = [];

    Object.entries(params).forEach(([key, value]) => {
        if (isArray(value)) {
            encodedParams.push(encodeArrayToURL(key, value));
        } else if (!isNil(value)) {
            encodedParams.push(`${key}=${value}`);
        }
    });

    return `${url}?${encodedParams.join("&")}`;
};
